module.exports = __webpack_public_path__ + "img/agt.a8d0b628.svg";